// extracted by mini-css-extract-plugin
export var cartIcon = "_o2-0";
export var cartIconContainer = "_o2-1";